import { Navigate } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'
import Loading from './Loading'

interface PrivateRouteProps {
  children: React.ReactNode
}

function PrivateRoute({ children }: PrivateRouteProps) {
  const { isAuthenticated, isLoading } = useAuth()

  console.log('PrivateRoute - isAuthenticated:', isAuthenticated, 'isLoading:', isLoading)

  if (isLoading) {
    return <Loading fullScreen />
  }

  if (!isAuthenticated) {
    console.log('PrivateRoute - Redirecting to login')
    return <Navigate to="/login" replace />
  }

  console.log('PrivateRoute - Access granted')
  return <>{children}</>
}

export default PrivateRoute